var modules = {
}

const files = require.context('.', false, /\.js$/)
files.keys().forEach((key) => {
  if (key === './index.js') {
    return
  }
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

const install = function (Vue, opts = {}) {
  Object.keys(modules).forEach(key => {
    Vue.prototype[`$ipsos${key}`] = modules[key]
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
export default install



// WEBPACK FOOTER //
// ./src/third/index.js